import React, { createContext, useState } from 'react';
import { urlConfig } from '../../config/urlConfig';
import {
  accessTokenRequest,
  getUserData,
  sendRequest,
} from '../global/global.service';

export const MeetingsContext = createContext();

export const MeetingsContextProvider = ({ children }) => {
  const [meetings, setMeetings] = useState([]);
  const [publicMeeting, setPublicMeeting] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const getPublicMeeting = () => {
    setIsLoading(true);
    setError(null);

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.public_meeting, response, 'get', null)
          .then((res) => {
            setPublicMeeting(res.data);
            setIsLoading(false);
          })
          .catch((err) => {
            console.log('get token err', err);
            setError(err.message);
            setIsLoading(false);
          });
      })
      .catch((err) => {
        console.log('get token err', err);
        setError(err.message);
        setIsLoading(false);
      });
  };

  //public meeting
  const checkIsHostExist = (members, user) => {
    let checker = false;

    members.map((item) => {
      if (item.member_uuid && item.member_uuid === user.uid) {
        checker = true;
      }
    });

    return checker;
  };

  const addMeeting = (meeting, user) => {
    let privateMeet = [];

    meeting &&
      meeting.map((item) => {
        if (item.is_public === false) {
          privateMeet.push(item);
        } else {
          if (
            item.members &&
            item.members.length > 0 &&
            checkIsHostExist(item.members, user)
          ) {
            privateMeet.push(item);
          }
        }
      });

    privateMeet.length > 0 && setMeetings([...privateMeet]);
  };

  const getMeeting = (user) => {
    setIsLoading(true);
    setError(null);
    getPublicMeeting();
    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.meeting_landing_url, response, 'get', null)
          .then((res) => {
            addMeeting(res.data, user);
            setIsLoading(false);
          })
          .catch((err) => {
            console.log('get token err', err);
            setError(err.message);
            setIsLoading(false);
          });
      })
      .catch((err) => {
        console.log('get token err', err);
        setError(err.message);
        setIsLoading(false);
      });
  };

  const getHostData = (meeting, users, setMeetingHost) => {
    let hostUid = '';
    let hostData = '';

    if (meeting.members.length > 0) {
      hostUid = meeting.members
        .filter((host) => host.status === 0)
        .map((user) => user.member_uuid)
        .toString();

      hostData =
        users &&
        users.length > 0 &&
        users.filter((user) => user.uid === hostUid).map((i) => i);

      hostData.length > 0 && setMeetingHost(hostData[0]);
    }
  };

  const addNoneMembers = (meeting, setMeetingUsers, users) => {
    const non_member = meeting.members
      .filter((item) => item.member_uuid === null)
      .map((i) => i);

    let newArr = [];

    if (non_member && non_member.length > 0) {
      non_member.map((i) =>
        newArr.push({
          email: i.email,
          meeting: i.meeting,
          member_uuid: null,
          status: i.status,
        })
      );
      setMeetingUsers([...users, ...newArr]);
    }
  };

  const getUsersData = (data, setMeetingHost, setMeetingUsers) => {
    const users_uuids = data.members
      .filter((item) => item.member_uuid !== null)
      .map((i) => i.member_uuid);

    if (users_uuids) {
      accessTokenRequest()
        .then((response) => {
          getUserData(
            {
              users_uuids,
            },
            response
          ).then((res) => {
            setMeetingUsers(res.data.members);
            getHostData(data, res.data.members, setMeetingHost);
            addNoneMembers(data, setMeetingUsers, res.data.members);
          });
        })
        .catch((e) => {
          console.log('users data error', e.response);
        });
    }
  };

  return (
    <MeetingsContext.Provider
      value={{
        meetings,
        publicMeeting,
        setPublicMeeting,
        error,
        isLoading,
        getMeeting,
        getUsersData,
        searchTerm,
        setSearchTerm,
      }}
    >
      {children}
    </MeetingsContext.Provider>
  );
};
